$(function () {
	const $membershipTable = $('.membership-table');

	$membershipTable.each(function () {
		const $this = $(this);
		if ($this[0].scrollWidth > $this.width()) {
			$this.addClass('scrollable');
			$this.attr("tabindex", "0");
			
			if ($this.hasClass('scrollable')) {
				$this.on("scroll", () => {
					$this.removeClass("scrollable")
					$this.off("scroll");
				});
			}
		}
	});

	const $expander = $('.membership-table__detail-expander');
	const newRand = () => Math.ceil(Math.random() * 1000000);

	$expander.each(function () {
		const $this = $(this);
		const $target = $this.siblings('.membership-table__record-description-container');
		const $icon = $this.children('i');
		let rand = newRand();
		$this.attr('id', `expander-${rand}`);
		$target.attr('id', `target-${rand}`);
		$this.attr('aria-controls', `target-${rand}`);
		$target.attr('aria-controlledby', `expander-${rand}`);
		$target.attr('aria-hidden', 'true');

		$this.on('click', e => {
			e.preventDefault();
			const $target = $this.siblings('.membership-table__record-description-container');

			//  START AND END VARS USED FOR FOR F.L.I.P. ANIMATION
			const start = $target.height();

			$icon.toggleClass('blue-icon-chevron-down_bold');
			$icon.toggleClass('blue-icon-chevron-up_bold');
			$target.toggleClass('open');

			const end = $target.height();

			$target[0].animate([{ height: `${start}px` }, { height: `${end}px` }], {
				duration: 500,
				easing: 'ease',
			});

			if ($target.hasClass('open')) {
				$target.attr('aria-hidden', 'false');
			} else {
				$target.attr('aria-hidden', 'true');
			}
		});
	});

	const $tooltipTrigger = $("i.membership-table__tooltip-trigger");

	const loadScript = async (scriptTag, scriptSrc, callback) => {
		await fetch(scriptSrc)
			.then((response) => {
				if (response.ok) {
					return response.text();
				} else {
					console.error("Error retrieving script resource");
					return;
				}
			})
			.then((data) => {
				scriptTag.innerHTML = data;
				document.body.insertAdjacentElement("beforeend", scriptTag);
				callback();
			});
	}

	if ($tooltipTrigger.length > 0) {
		const scriptTag = document.createElement("script");
		const scriptSrc = $("table.membership-table").attr("data-tooltip-script") || "/static/jquery-ui-tooltip.min.js";
		loadScript(scriptTag, scriptSrc, () => {
			$tooltipTrigger.each(function(index, value) {
				const $this = $(this);
				$this.attr("tabindex", "0");
				$this.tooltip({
					content: $this.attr("title"),
				});
			});
		});
	}
});
